import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';

const AddRiskModal = ({ open, onClose, risk, onSubmit, isLoading,projectId }) => {
  const [riskName, setRiskName] = useState("");

  useEffect(() => {
    setRiskName(risk?.title || "");
  }, [risk]);

  const handleSubmit = () => {
    if (!riskName.trim()) return;
    onSubmit({ riskName,projectId });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{risk ? "Edit Risk" : "Add Risk"}</DialogTitle>

      <DialogContent>
        <TextField
          label="Risk Name"
          fullWidth
          value={riskName}
          onChange={(e) => setRiskName(e.target.value)}
          margin="dense"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>

        <Button onClick={handleSubmit} disabled={isLoading} variant="contained">
          {isLoading ? <CircularProgress size={22} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddRiskModal;
